import Api from "./Api";

export class AuthenticationService extends Api {
  private static service: AuthenticationService;

  public static getInstance(): AuthenticationService {
    if (!AuthenticationService.service) {
      AuthenticationService.service = new AuthenticationService();
    }
    return AuthenticationService.service;
  }

  public async getUserInfo() {
    return await super.get(process.env.REACT_APP_URL_USER_INFO + '');
  }
}
